import { addDays, differenceInCalendarDays, format } from 'date-fns';

export const toDateKey = (value) => {
  if (!value) return null;
  if (typeof value === 'string') {
    const datePart = value.includes('T') ? value.split('T')[0] : value.split(' ')[0];
    return datePart;
  }
  return format(value, 'yyyy-MM-dd');
};

export const parseDateKey = (dateKey) => {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const formatRoadTripDayLabel = (dateKey, locale) => {
  return format(parseDateKey(dateKey), 'EEE, MMM d', locale ? { locale } : undefined);
};

export const addDaysToDateKey = (dateKey, amount) => {
  return format(addDays(parseDateKey(dateKey), amount), 'yyyy-MM-dd');
};

export const getDayIndexFromTripStart = (tripStartDate, dateKey) => {
  const startKey = toDateKey(tripStartDate);
  if (!startKey || !dateKey) return 0;
  return differenceInCalendarDays(parseDateKey(dateKey), parseDateKey(startKey));
};

export const isDateKeyWithinTrip = (dateKey, tripStartDate, tripEndDate) => {
  if (!dateKey || !tripStartDate || !tripEndDate) return true;
  const date = parseDateKey(dateKey);
  const start = parseDateKey(toDateKey(tripStartDate));
  const end = parseDateKey(toDateKey(tripEndDate));
  return date >= start && date <= end;
};

export const clampDateKeyToTrip = (dateKey, tripStartDate, tripEndDate) => {
  const startKey = toDateKey(tripStartDate);
  const endKey = toDateKey(tripEndDate);
  if (!dateKey || !startKey || !endKey) return dateKey;
  if (dateKey < startKey) return startKey;
  if (dateKey > endKey) return endKey;
  return dateKey;
};
